import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const ClassroomRegistrationPage = loadable(
  () => import('./ClassroomRegistrationPage'),
  {
    fallback: <BoxIndicator />,
  }
);

export default ClassroomRegistrationPage;
